export { default } from "./EditNote";
